module.exports = __webpack_public_path__ + "static/img/news1.26639d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news1.png
// module id = sYGX
// module chunks = 1